/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_O2Inputs */

const en_mk_sol_ukm_o2 = /** @type {(inputs: Mk_Sol_Ukm_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replies to customers stay consistent even when a different person types them`)
};

const id_mk_sol_ukm_o2 = /** @type {(inputs: Mk_Sol_Ukm_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan ke pelanggan konsisten meski yang mengetik berganti`)
};

/**
* | output |
* | --- |
* | "Replies to customers stay consistent even when a different person types them" |
*
* @param {Mk_Sol_Ukm_O2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_o2 = /** @type {((inputs?: Mk_Sol_Ukm_O2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_O2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_o2(inputs)
	return en_mk_sol_ukm_o2(inputs)
});